<template>
  <el-dialog
    title="编辑任务"
    :visible.sync="visible"
    width="1200px"
    custom-class="task-edit-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <div class="task-edit-container">
      <!-- 农事任务配置区域 -->
      <div class="task-config">
        <h3>农事任务</h3>
        <el-table :data="editForm.details" border style="width: 100%">
          <el-table-column
            label="序号"
            type="index"
            width="60"
            align="center"
          ></el-table-column>
          <el-table-column width="120">
            <template slot="header" slot-scope="">
              <span>大棚编号</span
              ><span style="color: #f56c6c; margin-left: 2px">*</span>
            </template>
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.greenhouseId"
                placeholder="请选择"
                style="width: 100%"
                size="small"
                @change="handleTaskGreenhouseChange(scope.$index)"
              >
                <el-option
                  v-for="item in greenhouseOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="150">
            <template slot="header" slot-scope="">
              <span>任务分类</span
              ><span style="color: #f56c6c; margin-left: 2px">*</span>
            </template>
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.categoryId"
                placeholder="请选择"
                style="width: 100%"
                size="small"
                @change="handleCategoryChange(scope.$index)"
              >
                <el-option
                  v-for="item in taskCategoryOptions"
                  :key="item.categoryId"
                  :label="item.label"
                  :value="item.categoryId"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="200">
            <template slot="header" slot-scope="">
              <span>农事动作</span
              ><span style="color: #f56c6c; margin-left: 2px">*</span>
            </template>
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.actions"
                placeholder="请先选择任务分类"
                size="small"
                style="width: 100%"
                @change="handleActionsChange(scope.$index)"
                :disabled="!scope.row.categoryId"
              >
                <el-option
                  v-for="action in getActionsOptions(scope.row.categoryId)"
                  :key="action.id"
                  :label="action.actions"
                  :value="action.actions"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="200">
            <template slot="header" slot-scope="">
              <span>重点防治病虫害</span>
            </template>
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.pestControl"
                placeholder="请输入"
                size="small"
              />
            </template>
          </el-table-column>
          <el-table-column width="200">
            <template slot="header" slot-scope="">
              <span>温湿度要求</span>
            </template>
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.stdHumidityTemp"
                placeholder="请输入"
                size="small"
              />
            </template>
          </el-table-column>
          <el-table-column width="250">
            <template slot="header" slot-scope="">
              <span>执行时间</span
              ><span style="color: #f56c6c; margin-left: 2px">*</span>
            </template>
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.execDateRange"
                type="daterange"
                size="small"
                style="width: 100%"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @input="handleExecDateChange(scope.$index)"
                @change="handleExecDateChange(scope.$index)"
                format="yyyy-MM-dd"
              />
            </template>
          </el-table-column>
          <el-table-column width="180">
            <template slot="header" slot-scope="">
              <span>执行人</span
              ><span style="color: #f56c6c; margin-left: 2px">*</span>
            </template>
            <template slot-scope="scope">
              <div class="executor-selector">
                <el-popover
                  :ref="`executorPopover${scope.$index}`"
                  placement="bottom"
                  width="500"
                  trigger="click"
                  @show="handleExecutorPopoverShow(scope.$index)"
                >
                  <div class="executor-popover-content">
                    <div class="executor-layout">
                      <div class="executor-left-panel">
                        <div class="panel-content">
                          <div class="executor-title">执行人</div>
                        </div>
                      </div>
                      <div class="executor-right-panel">
                        <div class="panel-content">
                          <el-radio-group
                            v-model="scope.row.executorId"
                            @change="handleExecutorSelect(scope.$index, $event)"
                          >
                            <el-radio
                              v-for="account in executorCascaderOptions"
                              :key="account.id"
                              :label="account.id"
                            >
                              {{ account.nickName }}
                            </el-radio>
                          </el-radio-group>
                        </div>
                      </div>
                    </div>
                    <div class="executor-popover-actions">
                      <el-button
                        size="mini"
                        @click="handleExecutorCancel(scope.$index)"
                        >取消</el-button
                      >
                      <el-button
                        size="mini"
                        type="primary"
                        @click="handleExecutorConfirm(scope.$index)"
                        >确定</el-button
                      >
                    </div>
                  </div>
                  <el-input
                    slot="reference"
                    v-model="scope.row.executorNickName"
                    placeholder="请选择执行人"
                    size="small"
                    readonly
                    style="width: 100%"
                  />
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="195">
            <template slot="header" slot-scope="">
              <span>优先级</span
              ><span style="color: #f56c6c; margin-left: 2px">*</span>
            </template>
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.priority"
                :min="1"
                :max="999"
                :precision="0"
                placeholder="请输入"
                size="small"
                style="width: 100%"
              />
            </template>
          </el-table-column>
          <el-table-column label="指导文件" width="120">
            <template slot-scope="scope">
              <div class="file-upload-container">
                <el-upload
                  v-if="
                    !scope.row.guidanceFiles ||
                    scope.row.guidanceFiles.length === 0
                  "
                  :action="uploadUrl"
                  :on-success="
                    (res, file) => handleUploadSuccess(res, scope.$index, file)
                  "
                  :on-error="handleUploadError"
                  :before-upload="
                    (file) => handleBeforeUpload(file, scope.$index)
                  "
                  :accept="'.pdf,.jpg,.jpeg,.png,.gif,.mp4'"
                  :show-file-list="false"
                  size="mini"
                >
                  <el-button size="mini" type="primary" icon="el-icon-upload"
                    >上传</el-button
                  >
                </el-upload>
                <div
                  v-if="
                    scope.row.guidanceFiles &&
                    scope.row.guidanceFiles.length > 0
                  "
                  class="file-list"
                >
                  <div class="file-item">
                    <span class="file-name">{{
                      getFileName(scope.row.guidanceFiles[0])
                    }}</span>
                    <div class="file-actions">
                      <el-button
                        type="text"
                        size="mini"
                        @click="replaceFile(scope.$index)"
                        style="color: #409eff; margin-right: 5px"
                        >替换</el-button
                      >
                      <el-button
                        type="text"
                        size="mini"
                        @click="removeFile(scope.$index, 0)"
                        style="color: #f56c6c"
                        >删除</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="注意事项" width="200">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.precautions"
                placeholder="请输入"
                size="small"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import axios from "@/axios";
import { baseUrl, uploadUrl } from "@/axios/baseUrl";
import dayjs from "dayjs";

export default {
  name: "TaskEditDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    taskData: {
      type: Object,
      default: () => ({}),
    },
    greenhouseOptions: {
      type: Array,
      default: () => [],
    },
    varietyOptions: {
      type: Array,
      default: () => [],
    },
    taskCategoryOptions: {
      type: Array,
      default: () => [],
    },
    executorCascaderOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      editForm: {
        id: "",
        details: [],
      },
      submitLoading: false,
      uploadUrl: "",
    };
  },
  mounted() {
    this.uploadUrl = uploadUrl;
  },
  watch: {
    visible(val) {
      if (val) {
        this.initFormData();
      }
    },
    taskData: {
      handler(newVal) {
        if (this.visible) {
          this.initFormData();
        }
      },
      deep: true,
    },
  },
  methods: {
    // 初始化执行人相关字段
    initExecutorFields(taskData) {
      // 确保执行人ID是数字格式
      if (taskData.executorId) {
        taskData.executorId = Number(taskData.executorId);
      }

      // 备份执行人原始值，用于取消时恢复
      this.$set(taskData, "originalExecutorId", taskData.executorId || "");
      this.$set(
        taskData,
        "originalExecutorUsername",
        taskData.executorUsername || ""
      );
      this.$set(
        taskData,
        "originalExecutorNickName",
        taskData.executorNickName || ""
      );
    },

    initFormData() {
      if (this.taskData && this.taskData.id) {
        // 将单个任务对象转换为表格中的第一条数据
        const taskData = { ...this.taskData };

        // 初始化执行时间范围
        if (taskData.execStartDate && taskData.execEndDate) {
          this.$set(taskData, "execDateRange", [
            new Date(taskData.execStartDate),
            new Date(taskData.execEndDate),
          ]);
        } else {
          this.$set(taskData, "execDateRange", []);
        }

        // 初始化文件相关字段
        if (!taskData.guidanceFiles) {
          taskData.guidanceFiles = [];
        }
        if (!taskData.pendingFiles) {
          taskData.pendingFiles = [];
        }

        // 初始化优先级
        if (!taskData.priority) {
          taskData.priority = 1;
        }

        // 初始化执行人相关字段
        this.initExecutorFields(taskData);

        // 设置表单数据
        this.editForm = {
          id: taskData.id,
          details: [taskData], // 将单个任务对象作为数组的第一项
        };

        // 更新执行人显示名称
        this.updateExecutorDisplayNames();
      }
    },

    // 从 assignDialog.vue 复制的方法
    getFileName(file) {
      const list = file.split("/");
      return list[list.length - 1];
    },

    formatDate(date) {
      if (!date) return "";
      return dayjs(date).format("YYYY-MM-DD");
    },

    // 任务大棚变化处理
    handleTaskGreenhouseChange(index) {
      const task = this.editForm.details[index];
      const selectedGreenhouse = this.greenhouseOptions.find(
        (item) => item.value === task.greenhouseId
      );
      if (selectedGreenhouse) {
        task.greenhouseName = selectedGreenhouse.label;
      }
    },

    // 任务分类变化处理
    handleCategoryChange(index) {
      const task = this.editForm.details[index];
      const selectedCategory = this.taskCategoryOptions.find(
        (item) => item.categoryId == task.categoryId
      );

      if (selectedCategory) {
        task.categoryName = selectedCategory.label;
        // 清空农事动作相关字段
        task.actions = "";
        task.pestControl = "";
        task.stdHumidityTemp = "";
      }
    },

    // 农事动作变化处理
    handleActionsChange(index) {
      const task = this.editForm.details[index];
      const selectedAction = this.getSelectedAction(
        task.categoryId,
        task.actions
      );
      if (selectedAction) {
        task.actions = selectedAction.actions || "";
        task.taskConfigId = selectedAction.id || "";
        task.pestControl = selectedAction.pestControl || "";
        task.stdHumidityTemp = selectedAction.stdHumidityTemp || "";
      }
    },

    // 执行人选择处理
    handleExecutorSelect(index, executorId) {
      const task = this.editForm.details[index];
      const executor = this.executorCascaderOptions.find(
        (item) => item.id === String(executorId)
      );
      if (executor) {
        this.$set(task, "executorId", Number(executorId));
        this.$set(task, "executorUsername", executor.username);
        this.$set(task, "executorNickName", executor.nickName);
      }
    },

    // 执行人弹出框显示
    handleExecutorPopoverShow(index) {
      const task = this.editForm.details[index];
      // 备份当前值，用于取消时恢复
      this.$set(task, "originalExecutorId", task.executorId || "");
      this.$set(task, "originalExecutorUsername", task.executorUsername || "");
      this.$set(task, "originalExecutorNickName", task.executorNickName || "");
    },

    // 执行人选择确认
    handleExecutorConfirm(index) {
      const task = this.editForm.details[index];

      if (!task.executorId) {
        this.$message.warning("请先选择执行人");
        return;
      }

      // 清除备份数据
      this.$delete(task, "originalExecutorId");
      this.$delete(task, "originalExecutorUsername");
      this.$delete(task, "originalExecutorNickName");

      const popoverRef = this.$refs[`executorPopover${index}`];
      if (popoverRef && popoverRef.doClose) {
        popoverRef.doClose();
      }
    },

    // 执行人选择取消
    handleExecutorCancel(index) {
      const task = this.editForm.details[index];

      // 恢复原始值
      this.$set(task, "executorId", task.originalExecutorId || "");
      this.$set(task, "executorUsername", task.originalExecutorUsername || "");
      this.$set(task, "executorNickName", task.originalExecutorNickName || "");

      // 清除备份数据
      this.$delete(task, "originalExecutorId");
      this.$delete(task, "originalExecutorUsername");
      this.$delete(task, "originalExecutorNickName");

      const popoverRef = this.$refs[`executorPopover${index}`];
      if (popoverRef && popoverRef.doClose) {
        popoverRef.doClose();
      }
    },

    // 执行时间变化处理
    handleExecDateChange(index) {
      const task = this.editForm.details[index];

      if (task.execDateRange && task.execDateRange.length === 2) {
        const startDate =
          task.execDateRange[0] instanceof Date
            ? task.execDateRange[0]
            : new Date(task.execDateRange[0]);
        const endDate =
          task.execDateRange[1] instanceof Date
            ? task.execDateRange[1]
            : new Date(task.execDateRange[1]);

        task.execStartDate = this.formatDate(startDate);
        task.execEndDate = this.formatDate(endDate);

        this.$set(this.editForm.details[index], "execDateRange", [
          startDate,
          endDate,
        ]);
      }
    },

    // 文件上传前验证
    handleBeforeUpload(file, taskIndex) {
      const allowedTypes = ["pdf", "jpg", "jpeg", "png", "gif", "mp4"];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!allowedTypes.includes(fileExtension)) {
        this.$message.error("只支持上传 PDF、JPG、PNG、GIF、MP4 格式的文件");
        return false;
      }

      const maxSize = 50 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$message.error("文件大小不能超过 50MB");
        return false;
      }

      const task = this.editForm.details[taskIndex];
      if (!task.pendingFiles) {
        task.pendingFiles = [];
      }
      task.pendingFiles.push({
        name: file.name,
        size: file.size,
      });

      return true;
    },

    // 文件上传成功处理
    handleUploadSuccess(res, index, file) {
      if (res.code === 200) {
        const task = this.editForm.details[index];
        if (!task.guidanceFiles) {
          task.guidanceFiles = [];
        }

        let localFileName = file.name;
        if (task.pendingFiles && task.pendingFiles.length > 0) {
          const pendingFile = task.pendingFiles.find(
            (pending) =>
              pending.name === file.name && pending.size === file.size
          );
          if (pendingFile) {
            localFileName = pendingFile.name;
            const pendingIndex = task.pendingFiles.indexOf(pendingFile);
            if (pendingIndex > -1) {
              task.pendingFiles.splice(pendingIndex, 1);
            }
          }
        }

        task.guidanceFiles = [res.data];
        this.$message.success("文件上传成功");
      } else {
        this.$message.error(res.message || "文件上传失败");
      }
    },

    // 文件上传失败处理
    handleUploadError() {
      this.$message.error("文件上传失败");
    },

    // 删除文件
    removeFile(taskIndex, fileIndex) {
      const task = this.editForm.details[taskIndex];
      if (task.guidanceFiles && task.guidanceFiles.length > fileIndex) {
        task.guidanceFiles.splice(fileIndex, 1);
        this.$message.success("文件删除成功");
      }
    },

    // 替换文件
    replaceFile(taskIndex) {
      const task = this.editForm.details[taskIndex];
      task.guidanceFiles = [];
      this.$message.info("请选择新文件进行替换");
    },

    // 下载文件
    downloadFile(fileUrl) {
      try {
        const fileName = this.getFileName(fileUrl);
        const link = document.createElement("a");
        link.href = baseUrl + fileUrl;
        link.download = fileName;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$message.success("文件下载已开始");
      } catch (error) {
        console.error("文件下载失败:", error);
        this.$message.error("文件下载失败");
      }
    },

    // 更新执行人显示名称
    updateExecutorDisplayNames() {
      if (this.editForm.details && this.editForm.details.length > 0) {
        this.editForm.details.forEach((task, index) => {
          if (task.executorId) {
            const executor = this.executorCascaderOptions.find(
              (item) => item.id === String(task.executorId)
            );
            if (executor) {
              this.$set(
                this.editForm.details[index],
                "executorUsername",
                executor.name
              );
              this.$set(
                this.editForm.details[index],
                "executorNickName",
                executor.nickName
              );
            }
          }
        });
      }
    },

    // 获取指定分类下的农事动作选项
    getActionsOptions(categoryId) {
      if (!categoryId || !this.taskCategoryOptions) return [];
      const category = this.taskCategoryOptions.find(
        (item) => item.categoryId == categoryId
      );
      if (category && category.categoryActionsList) {
        return category.categoryActionsList;
      }
      return [];
    },

    // 根据分类ID和农事动作获取对应的动作详情
    getSelectedAction(categoryId, actions) {
      if (!categoryId || !actions || !this.taskCategoryOptions) return null;
      const category = this.taskCategoryOptions.find(
        (item) => item.categoryId == categoryId
      );
      if (category && category.categoryActionsList) {
        return category.categoryActionsList.find(
          (action) => action.actions === actions
        );
      }
      return null;
    },
    async handleSubmit() {
      // 校验表格中的必填项
      if (!this.validateTableData()) {
        return;
      }

      this.submitLoading = true;

      try {
        // 由于表格中只有一条数据，我们直接提交这条数据
        const taskData = this.editForm.details[0];
        const submitData = {
          id: this.editForm.id,
          ...taskData,
        };

        console.log("编辑数据", submitData);

        const res = await axios.post(
          baseUrl + "/api/digital-farming/task/allot-record/edit",
          submitData
        );
        if (res.code === 200) {
          this.$message.success("任务编辑成功");
          this.$emit("success");
          this.handleClose();
        } else {
          this.$message.error(res.message || "编辑失败");
        }
      } catch (error) {
        console.error("编辑失败:", error);
        this.$message.error("编辑失败");
      } finally {
        this.submitLoading = false;
      }
    },

    validateTableData() {
      // 由于表格中只有一条数据，直接验证这条数据
      const task = this.editForm.details[0];

      if (!task.greenhouseId) {
        this.$message.error("请选择大棚编号");
        return false;
      }

      if (!task.categoryId) {
        this.$message.error("请选择任务分类");
        return false;
      }

      if (!task.actions || task.actions.trim() === "") {
        this.$message.error("请输入农事动作");
        return false;
      }

      if (!task.execDateRange || task.execDateRange.length !== 2) {
        this.$message.error("请选择执行时间");
        return false;
      }

      if (!task.executorId) {
        this.$message.error("请选择执行人");
        return false;
      }

      if (!task.priority || task.priority < 1) {
        this.$message.error("请输入有效的优先级（1-999）");
        return false;
      }

      return true;
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.resetForm();
    },
    resetForm() {
      this.editForm = {
        id: "",
        details: [],
      };
    },
  },
};
</script>

<style scoped lang="less">
/* 编辑弹窗样式 */
.task-edit-dialog {
  .el-dialog__header {
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
    color: #fff;
    border-bottom: 1px solid #2c3e50;
  }

  .el-dialog__body {
    background: #0f1419;
    color: #fff;
    padding: 20px;
  }

  .el-dialog__footer {
    background: #0f1419;
    border-top: 1px solid #2c3e50;
  }
}

.task-edit-container {
  .section-title {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid #2680dd;
  }

  .task-config {
    margin-bottom: 20px;

    h3 {
      color: #fff;
      margin-bottom: 15px;
      font-size: 16px;
    }
  }
}

/* 文件上传样式 */
.file-upload-container {
  .file-list {
    margin-top: 5px;

    .file-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 2px 0;
      font-size: 12px;

      .file-name {
        color: #409eff;
        max-width: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .file-actions {
        display: flex;
        align-items: center;
      }
    }
  }
}

/* 执行人选择器样式 */
.executor-selector {
  position: relative;
  display: inline-block;
  width: 100%;

  .el-input {
    cursor: pointer;

    &:hover {
      .el-input__inner {
        border-color: #409eff;
      }
    }
  }
}

/* 执行人弹出框样式 */
.executor-popover-content {
  padding: 0;

  .executor-layout {
    display: flex;
    min-height: 200px;

    .executor-left-panel {
      width: 80px;
      text-align: center;
      padding: 8px 0;
      background-color: #f5f7fa;
      border-right: 1px solid #ebeef5;

      .executor-title {
        color: #303133;
        font-size: 14px;
        font-weight: 500;
      }
    }

    .executor-right-panel {
      flex: 1;
      min-width: 200px;

      .panel-content {
        padding: 8px 0;
        max-height: 150px;
        overflow-y: auto;

        .el-radio-group {
          .el-radio {
            margin: 0;
            padding: 8px 16px;
            width: 100%;
            display: block;
            border-radius: 0;
            transition: all 0.3s;

            &:hover {
              background-color: #f0f9ff;
              color: #409eff;
            }

            &.is-checked {
              background-color: #ecf5ff;
              color: #409eff;
            }

            .el-radio__label {
              font-size: 13px;
            }
          }
        }
      }
    }
  }

  .executor-popover-actions {
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 16px;
    border-top: 1px solid #ebeef5;
    background-color: #fff;

    .el-button {
      min-width: 60px;
    }
  }
}
</style>
